// src/components/ModalFPassword.js
import React, { useState, useContext } from 'react';
import API from '../api/client';
import { ModalContext } from '../context/ModalContext';
import './ModalFPassword.css';

const ModalFPassword = () => {
  const { closeModal } = useContext(ModalContext);
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [infoMessage, setInfoMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setInfoMessage(null);

    if (!email.trim()) {
      setError('Por favor, introduce tu correo.');
      return;
    }

    setLoading(true);
    try {
      // 1) Llamada al endpoint /auth/forgot-password/
      await API.post('/auth/forgot-password/', { email: email.trim() });

      // 2) Mostrar mensaje genérico (siempre)
      setInfoMessage(
        'Si existe una cuenta asociada a este correo, recibirás un email con instrucciones.'
      );

      // 3) Opcional: cerramos automáticamente el modal después de 2 segundos
      setTimeout(() => {
        closeModal();
      }, 2000);
    } catch (err) {
      // 4) En cualquier caso (errores de red, 500, etc.) mostramos el mismo mensaje genérico
      setInfoMessage(
        'Si existe una cuenta asociada a este correo, recibirás un email con instrucciones.'
      );
      setTimeout(() => {
        closeModal();
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-modal-overlay" onClick={() => closeModal()}>
      <div className="forgot-modal" onClick={(e) => e.stopPropagation()}>
        <div className="forgot-modal-header">
          <h5>Recuperar contraseña</h5>
          <button
            className="close-button"
            onClick={() => closeModal()}
            aria-label="Cerrar"
          >
            &times;
          </button>
        </div>

        <div className="forgot-modal-body">
          {error && <div className="error">{error}</div>}
          {infoMessage && <div className="info">{infoMessage}</div>}

          {!infoMessage && (
            <form onSubmit={handleSubmit} className="form">
              <div className="form-group">
                <label>Correo electrónico:</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tucorreo@ejemplo.com"
                  required
                />
              </div>

              <div className="actions">
                <button
                  type="button"
                  className="btn secondary"
                  onClick={() => closeModal()}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn" disabled={loading}>
                  {loading ? 'Enviando...' : 'Enviar enlace'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalFPassword;
